import { render } from "./PaymentStep.vue?vue&type=template&id=10340ce4"
import script from "./PaymentStep.vue?vue&type=script&lang=js"
export * from "./PaymentStep.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__